const ARIA_LABELS = {
    CART: {
        decreaseQuantity: "Decrease item quantity by 1",
        increaseQuantity: "Increase item quantity by 1",
        currentQuantity: (quantity: number) => `Current quantity selected: ${quantity}`,
        emptyCart: 'No items in cart, click to open the cart',
        cartWithItems: (totalItems: number) => `${totalItems} ${totalItems === 1 ? 'item' : 'items'} in cart, click to open`,
        productName: "Product Name",
        subItemPrice: "SubItem Price",
        size: "Size",
        removedItem: "Remove item from cart",
        editItem: "Edit item from cart",
        totalItemPrice: "Total Item Price",
        status: "Status",
        subtotal: "Subtotal",
        addItems: "Add Items",
        proceedToCheckout: "Proceed To Checkout",
        checkout: "Checkout",
    },
    REWARDS: {
        close: "close",
        back: "back",
        proceed: "proceed",
    },
    LOGIN: {},
    RECENT_ORDERS: {
        reOrderNow: "Re-Order Now",
        customizeWith: (customization: string) => `customized with ${customization}`,
        reOrderNowDescription: (orderDescription: string) => `Re-Order ${orderDescription}`,

    },
    PICKUP_MODAL: {
        selectLater: "select later",
        selectASAP: "select asap",
        close: "close",
    },
} as const;

export default ARIA_LABELS;
